import {Modal} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import {useContext} from "react";
import EventsMiniCard from "./pane/EventsMiniCard";

export default function ClientLookupEventsModal(props) {

  const [context, setContext] = useContext(AppContext);

  const handleClose = () => {
    props.handleClose();
  };

  const registerFn = (event) => {
    props.handleSave(event);
  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={true}>
      <Modal.Header closeButton>
        <Modal.Title>Events
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EventsMiniCard
          hideDesc={true}
          reservation={props?.reservation}
          client={props.client}
          register={registerFn}
        />
      </Modal.Body>
    </Modal>
  );
}